/* 🤖 this file was generated by svg-to-ts */
export const IconBigBoldLogout: {
    name: 'big-bold-logout';
    data: string;
} = {
    name: 'big-bold-logout',
    data: `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 128 128"><path d="M64 92.5a7.5 7.5 0 0 0 7.5-7.5V8a7.5 7.5 0 0 0-15 0v77a7.5 7.5 0 0 0 7.5 7.5"/><path d="M95.18 19.26a7.5 7.5 0 1 0-8 12.67 43.66 43.66 0 1 1-48.88 1.49 7.5 7.5 0 0 0-8.78-12.16 58.67 58.67 0 1 0 65.66-2"/></svg>`,
};
